<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer006">
<p class="Ahead ParaOverride-1"><span class="com-rorohiko-pagestaker-style">xv</span></p>
<p class="_acks" id="_idParaDest-4"> <a id="_idTextAnchor001"></a> Acknowledgments</p>
<p class="txni">Books don’t write themselves, you know. In addition to the haggard author, there is always an indispensable and ragtag army that brings tea, ignores the mess, and exclaims over the smallest success. That army, for me, consists of Joe, Kat, Jeff, and the ever-hungry Pepper Jack; my Patreon supporters (whom I refer to as my Matreons); the Mother Grove Goddess Temple Circle of Council and the wonderful volunteers who keep the home fires burning in my absence; and the vast, beautiful community that has formed on Facebook. My editor (and friend) Heather Greene, Lauryn Heineman, Shannon McKuhen, Donna Burch-Brown, and the rest of the team at Llewellyn take thousands of words and transform them into a real, live book and have my gratitude and respect. I asked several friends who wear prosthetic devices, notably Angie and Monica, if I could hear more about the intricacies of their magical practice, and they graciously responded. Barb, Al, and Friends at the Farm gave me space, time, and quiet to work on edits. All these beings are golden. If there is any confusion or any inadequacies, they are mine and mine alone.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acks.vue?669cb373